import { FunctionComponent, useContext } from "react";
import { Box, Flex, Text, Button, Stack, SkeletonText } from "@chakra-ui/react";

import { ReactComponent as AmlExclusiveBanner } from "src/assets/images/aml_exclusive.svg";
import { ReactComponent as PlayIcon } from "src/assets/images/play.svg";
import { ReactComponent as SpotlightIcon } from "src/assets/images/spotlight_ellipse.svg";
import { EmptyState, SectionTitle } from "src/components";
import { SpotlightContext } from "src/Context/Radarspotlight";
import { format } from "date-fns";

type Props = {
  handleViewVideo: any;
};

const Exclusive: FunctionComponent<Props> = ({ handleViewVideo }) => {
  const { data, isFetching } = useContext(SpotlightContext);

  const url =
    "https://prembly-assets.s3.us-east-2.amazonaws.com/idradar+onboard+screen.mp4";

  return (
    <Box mt={10}>
      <Stack direction={"row"} gap={3}>
        <Box width={"60%"} borderRight={"1px solid #E6E6E6"} pr={2}>
          <SectionTitle label="IdentityRadar Exclusive" />
          <Flex
            mb={8}
            mt={4}
            gap={4}
            direction={{ base: "column", md: "row" }}
            alignItems={"flex-start"}
          >
            <Box width={"40%"}>
              <AmlExclusiveBanner
                style={{ objectFit: "cover", width: "100%", height: "200px" }}
              />
            </Box>
            <Box width={"60%"}>
              <Text w={"100%"} fontSize={"14px"} color="#0B0A0A" mt={2} mb={5}>
                Prevent multiple account registrations, fraudsters, and block
                bots, using our comprehensive registration monitoring tool.
              </Text>
              <Button
                variant="contained"
                bg="primary"
                leftIcon={<PlayIcon />}
                onClick={() => handleViewVideo(url)}
                color={"#fff"}
              >
                Watch video
              </Button>
            </Box>
          </Flex>
        </Box>
        <Box width={"40%"}>
          <SectionTitle label="IdentityRadar Ads" />
          <Box mt={6}>
            {isFetching ? (
              <SkeletonText
                isLoaded={!isFetching}
                noOfLines={6}
                skeletonHeight={4}
                spacing={4}
              />
            ) : data && data.length > 0 ? (
              data.map((ads: any) => (
                <Box mt={4}>
                  <Text
                    bg={"#F6F3FF"}
                    borderRadius={"16px"}
                    padding={"5px 10px"}
                    color={"#0B0A0A"}
                    fontWeight={400}
                    fontSize={"13px"}
                    width={"fit-content"}
                  >
                    {ads.tag}
                  </Text>
                  <Text
                    color={"#1A1A1A"}
                    fontSize={"14px"}
                    fontWeight={400}
                    pt={2}
                  >
                    {ads.description}
                  </Text>
                  <Stack
                    direction={"row"}
                    alignItems={"center"}
                    justifyContent={"space-between"}
                    mt={3}
                  >
                    <Text
                      as={"a"}
                      href={ads.link_src}
                      color={"#251169"}
                      textDecoration={"underline"}
                      target="_blank"
                      fontSize={"14px"}
                    >
                      {ads.link_title}
                    </Text>
                    <Text
                      color={"#CF19A0"}
                      fontWeight={400}
                      fontSize={"14px"}
                      bg={"#F6F3FF"}
                      width={"fit-content"}
                      borderRadius={"24px"}
                      padding={"8px 12px"}
                      display={"flex"}
                      alignItems={"center"}
                      gap={2}
                    >
                      <SpotlightIcon />
                      {ads.event_text}: {format(ads.event_date, "dd MMMM yyyy")}
                    </Text>
                  </Stack>
                </Box>
              ))
            ) : (
              <EmptyState label="No Latest Ads" height="200px" />
            )}
          </Box>
        </Box>
      </Stack>
    </Box>
  );
};

export default Exclusive;
